import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.regexp.exec.js";
import { defineComponent as _defineComponent } from 'vue';
import { FundStrategy } from '~/types/types';
import { useCreateDemoPortfolioMutation } from '~/types/types';
export default /*#__PURE__*/_defineComponent({
  __name: 'CreateDemoPortfolio',
  emits: ['close'],
  setup: function setup(__props, _ref) {
    var emit = _ref.emit;
    var form = ref();
    var isFormValid = ref(false);
    var isLoading = ref(false);
    var email = ref('');
    var password = ref('');
    var customerName = ref('');
    var enableEsg = ref(false);
    var enableImpact = ref(false);
    var enableFund = ref(false);
    var fundStrategy = ref(FundStrategy.Article_8Plus);
    var fundIncludeKfw = ref(false);
    var fundIncludePai = ref(false);
    var includeTheoryOfChange = ref(false);
    var includeGhg = ref(false);
    var fundStrategyOptions = [{
      label: 'Article 6',
      value: FundStrategy.Article_6
    }, {
      label: 'Article 8',
      value: FundStrategy.Article_8
    }, {
      label: 'Article 8+',
      value: FundStrategy.Article_8Plus
    }, {
      label: 'Article 9',
      value: FundStrategy.Article_9
    }];
    var rules = {
      required: function required(value) {
        return !!value || 'This field is required';
      },
      email: function email(value) {
        var pattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return pattern.test(value) || 'Email must be valid';
      }
    };
    var _useCreateDemoPortfol = useCreateDemoPortfolioMutation(),
      mutate = _useCreateDemoPortfol.mutate,
      onDone = _useCreateDemoPortfol.onDone,
      onError = _useCreateDemoPortfol.onError;
    var handleCreate = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var input;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (isFormValid.value) {
                _context.next = 2;
                break;
              }
              return _context.abrupt("return");
            case 2:
              isLoading.value = true;
              input = {
                email: email.value,
                password: password.value,
                customerName: customerName.value,
                enableEsg: enableEsg.value || undefined,
                enableImpact: enableImpact.value || undefined,
                enableFund: enableFund.value || undefined
              };
              if (enableFund.value) {
                input.fundStrategy = fundStrategy.value;
                input.fundIncludeKfw = fundIncludeKfw.value || undefined;
                input.fundIncludePai = fundIncludePai.value || undefined;
              }
              if (enableImpact.value) {
                input.includeTheoryOfChange = includeTheoryOfChange.value || undefined;
                input.includeGhg = includeGhg.value || undefined;
              }
              mutate({
                input: input
              });
            case 7:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function handleCreate() {
        return _ref2.apply(this, arguments);
      };
    }();
    onDone(function () {
      var _window$$nuxt;
      isLoading.value = false;
      (_window$$nuxt = window.$nuxt) === null || _window$$nuxt === void 0 ? void 0 : _window$$nuxt.$emit('userMsg', {
        message: 'Account created',
        color: 'success'
      });
      emit('close');
    });
    onError(function () {
      isLoading.value = false;
      emit('close');
    });
    return {
      __sfc: true,
      emit: emit,
      form: form,
      isFormValid: isFormValid,
      isLoading: isLoading,
      email: email,
      password: password,
      customerName: customerName,
      enableEsg: enableEsg,
      enableImpact: enableImpact,
      enableFund: enableFund,
      fundStrategy: fundStrategy,
      fundIncludeKfw: fundIncludeKfw,
      fundIncludePai: fundIncludePai,
      includeTheoryOfChange: includeTheoryOfChange,
      includeGhg: includeGhg,
      fundStrategyOptions: fundStrategyOptions,
      rules: rules,
      mutate: mutate,
      onDone: onDone,
      onError: onError,
      handleCreate: handleCreate
    };
  }
});